import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

interface CreateMachineServiceInput {
  name: string;
  isDefault: boolean;
  priority: number;
}
export async function createMachineService(input: CreateMachineServiceInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
          mutation createMachineService (
            $input: CreateMachineServiceInput!
          ){
            createMachineService(
                createMachineServiceInput: $input
              )  
          }
          `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}

export async function getMachineServicesList(where:{} = {}) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                query getAllMachineService( $where :MachineServicesResolver_GetAllMachineService_FilterInputType) {
                    getAllMachineService (where :$where) {
                      id
                      name
                      isDefault
                      priority
                    }
                  }
                `,
      variables: {where},
    },
  });
  return data?.data?.data?.getAllMachineService;
}

interface UpdateMachineServiceInput {
  name: string;
  isDefault: boolean;
  priority: number;
}
export async function updateMachineService(input: UpdateMachineServiceInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            mutation updateMachineService (
              $input: UpdateMachineServiceInput!
            ){
              updateMachineService(
                    updateMachineServiceInput: $input
                ) 
            }
            `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}
